module.exports = __webpack_public_path__ + "assets/img/ic-save.cc816611.svg";